module.exports = __webpack_public_path__ + "img/homeSec01Top3.63c57766.jpg";